import { Intent, Tag } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import * as React from 'react'

interface Props {
  preference: 'PREFERRED' | 'NOT_PREFERRED'
  large?: boolean
}

export const PreferredItemTag: React.FC<Props> = props => {
  if (props.preference === 'PREFERRED') {
    return (
      <Tag large={props.large} minimal icon={IconNames.SMALL_TICK} intent={Intent.SUCCESS}>
        Send
      </Tag>
    )
  }

  return (
    <Tag large={props.large} minimal icon={IconNames.SMALL_CROSS} intent={Intent.DANGER}>
      Don&apos;t send
    </Tag>
  )
}
